<template>
  <v-row no-gutters class="pa-5 full-height justify-md-center">
    <v-row
      justify="center"
      class="ml-sm-1 col-md-12 col-2 mb-0"
      :class="{ 'xs-title': !$vuetify.breakpoint.mdAndUp }"
    >
      <v-col>
        <Icon
          name="crownrewards"
          :color="$vuetify.theme.themes.light.secondary"
          :style="{
            height: '35px',
            width: '35px',
            'vertical-align': 'inherit',
          }"
        ></Icon>
        <span
          class="secondary--text font-weight-bold text-h6"
          style="vertical-align: top"
          >YOUR STORE REWARDS</span
        >
      </v-col>
    </v-row>
    <v-col
      cols="12"
      :sm="hasBothRewardTypesOrNon ? '12' : '6'"
      :lg="hasBothRewardTypesOrNon ? '6' : '5'"
      xl="5"
      md="9"
      v-if="hasRewardsEarned"
    >
      <v-row class="full-height">
        <v-col
          :sm="hasBothRewardTypesOrNon ? '4' : '6'"
          cols="4"
          v-if="hasPoints"
          class="pa-2 pa-sm-3"
          ><PointsTab
        /></v-col>
        <div v-if="hasClubs" style="display: contents">
          <v-col
            cols="4"
            :sm="hasBothRewardTypesOrNon ? '4' : '6'"
            v-for="club in getTopTwoEarningsClubs()"
            :key="club.club_id"
            class="pa-2 pa-sm-3"
          >
            <ClubTab :club="club" :rewardsTemplate="true" />
          </v-col>
          <v-col
            :sm="hasBothRewardTypesOrNon ? '4' : '6'"
            cols="4"
            v-if="hasClubs && getTopTwoEarningsClubs().length < 2"
          >
            <div
              class="full-height no-clubs d-flex align-center justify-center py-10"
            >
              <span class="text-center">
                NO <br />
                REWARD <br />YET!
              </span>
            </div>
          </v-col>
        </div>
      </v-row>
    </v-col>
    <v-col
      class=""
      cols="12"
      :sm="hasBothRewardTypesOrNon ? '12' : '6'"
      :md="hasRewardsEarned ? '3' : undefined"
      :lg="hasBothRewardTypesOrNon ? '6' : '7'"
      xl="7"
    >
      <v-row
        align="center"
        class="full-height"
        :class="
          hasBothRewardTypesOrNon || !hasRewardsEarned || hasClubs
            ? 'justify-center'
            : 'justify-start'
        "
      >
        <v-col class="d-flex flex-column align-center pl-md-5" cols="auto">
          <span
            class="font-weight-light text-h5 text-md-h4"
            style="white-space: nowrap"
            v-if="!hasRewardsEarned"
          >
            No Rewards Earned Yet!
          </span>
          <p
            :class="{ 'text-h6': $vuetify.breakpoint.mdAndUp }"
            class="font-weight-bold text-center mt-4 mt-md-0"
            :style="!hasRewardsEarned ? 'white-space: nowrap;' : ''"
          >
            To View All Rewards
          </p>
          <v-btn
            class="mb-4 px-lg-16"
            color="secondary"
            large
            rounded
            :to="{ name: 'account', hash: '#rewards' }"
          >
            <div
              class="align-center d-flex font-size-md font-weight-semibold text-capitalize"
            >
              <Icon
                :class="hasRewardsEarned ? 'd-md-none d-lg-block' : ''"
                name="crownrewards"
                :color="'white'"
                :style="{
                  height: '35px',
                  width: '35px',
                }"
              ></Icon>
              <span :class="hasRewardsEarned ? 'd-md-none d-lg-block' : ''"
                >Go To&nbsp;</span
              >
              Rewards
            </div>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Icon from "@/components/UI/Icon.vue";
import PointsTab from "@/components/About/PointsTab.vue";
import ClubTab from "@/views/Rewards/ClubTab.vue";
import { mapGetters, mapState } from "vuex";

export default {
  name: "RewardsAfterAuth",
  components: { ClubTab, Icon, PointsTab },
  computed: {
    ...mapGetters("store", {
      clubs: "clubs",
      total_points_remaining: "total_points_remaining",
    }),
    ...mapGetters("store", { hasPoints: "hasPoints", hasClubs: "hasClubs" }),
    ...mapState({
      pointsOffers: (state) => state.store.info.points_offers,
    }),
    hasBothRewardTypesOrNon() {
      return (
        (this.hasPoints &&
          this.hasClubs &&
          this.getTopTwoEarningsClubs().length) ||
        (!this.hasPoints &&
          (!this.hasClubs || !this.getTopTwoEarningsClubs().length))
      );
    },
    hasRewardsEarned() {
      return (
        this.clubs.find((e) => e.free_products_qty) ||
        this.pointsOffers.find((e) => e.points <= this.total_points_remaining)
      );
    },
  },
  methods: {
    getTopTwoEarningsClubs() {
      const filteredClubs = this.clubs.filter(
        (item) =>
          item.free_products_qty !== 0 || item.stars_in_this_cycle !== 0,
      );
      filteredClubs.sort((a, b) => {
        if (a.free_products_qty || b.free_products_qty)
          return b.free_products_qty - a.free_products_qty;
        else return b.stars_in_this_cycle - a.stars_in_this_cycle;
      });
      return filteredClubs.slice(0, 2);
    },
  },
};
</script>

<style scoped>
.tab {
  background-color: var(--v-background-base);
  border-radius: 8px;
  position: relative;
  justify-content: center;
}
.no-clubs {
  border: 5px dashed #dbdbdb;
  border-radius: 8px;
  color: #dbdbdb;
  font-size: 20px;
}
.xs-title {
  text-wrap: nowrap;
  transform: scale(0.9);
}
.col-4:last-of-type > .tab {
  margin-left: 0 !important;
}
</style>
